"use client";

/* -----------------Components--------------- */
import { Container } from "@/components/Container";
import {
	AdaptiveText,
	type AdaptiveTextProps,
	Title,
} from "@/components/Content";
import { TimelineStat } from "@/components/TimelineStat";
import { motion } from "framer-motion";

/* -----------------Helpers--------------- */
import { cn } from "@/lib/utils";

type TimelineItem = {
	name: string;
	date: string;
	dateTime: string;
	description: AdaptiveTextProps["portableText"];
};

export type RoadmapProps = {
	title: string;
	text: AdaptiveTextProps["portableText"];
	timeline: TimelineItem[];
	id?: string;
	className?: string;
};

const Roadmap = ({ title, text, timeline, id, className }: RoadmapProps) => {
	return (
		<section id={id}>
			<Container
				className={cn("relative isolate", className)}
				containerClassName="pt-24 pb-32"
			>
				<motion.div
					className="mx-auto max-w-7xl px-6 lg:px-8"
					initial={{ opacity: 0 }}
					whileInView={{ opacity: 1 }}
					viewport={{ once: true }}
					transition={{ duration: 0.5 }}
				>
					<motion.div
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.6, delay: 0.1 }}
					>
						<Title className="text-4xl/[0.9] sm:text-5xl/[0.8] md:text-6xl/[0.8]">
							{title}
						</Title>
					</motion.div>

					<motion.div
						initial={{ opacity: 0, y: 15 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.6, delay: 0.2 }}
					>
						<AdaptiveText
							portableText={text}
							className="mt-4 text-base/7 sm:text-lg/8"
						/>
					</motion.div>

					<motion.div
						className="mt-16 sm:mt-24"
						initial={{ opacity: 0, y: 30 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.7, delay: 0.3 }}
					>
						<TimelineStat timeline={timeline} />
					</motion.div>
				</motion.div>
			</Container>
		</section>
	);
};

export default Roadmap;
